import React from 'react';

const RuntimeConfigGridToolbar = ({ label, placeholder, value, onChange, testId }) => (
  <div className="runtime-config-grid-toolbar">
    <input
      type="search"
      aria-label={label}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testId}
    />
  </div>
);

export default RuntimeConfigGridToolbar;
